module.exports = __webpack_public_path__ + "img/googleCalendar.8297cf2c.svg";